<div class="container pb-4 pt-4">
  <app-breadcrumb currentRouteName="Mon compte"></app-breadcrumb>
  <h1 class="pt-3 pb-2">Mon compte</h1>

  @if ($profile | async; as profile) {
    <div class="content">
      <div class="p-4 block">
        <h3>Mes informations</h3>
        @if ((profile.me != null && profile.account != null)) {
          <div>
            <div>{{ profile.me.firstname }} {{ profile.me.lastname }}</div>
            <div>{{ profile.account.name }}</div>
            <div>{{ profile.me.email }}</div>
            <div>{{ profile.me.phone }}</div>
          </div>
        } @else {
          <div class="alert alert-danger">
            <p>Compte introuvable</p>
            Merci de contacter le service client Libriciel
          </div>
        }
        <div class="text-info action-line">
          <fa-icon size="lg" icon="edit" class="me-2"></fa-icon>
          <a [routerLink]="[]" class="text-info" (click)="resetPasswordRequest()">Modifier mon mot de passe</a>
        </div>
        <div class="text-danger action-line">
          <fa-icon size="lg" icon="trash-alt" class="me-2"></fa-icon>
          <a [routerLink]="[]" (click)="deleteAccountRequest()" class="text-danger">Demander la suppression de mon
          compte</a>
        </div>
        <div class="alert alert-info d-flex align-items-center grid-gap-05rem">
          <div>
            <fa-icon size="lg" icon="info-circle"></fa-icon>
          </div>
          <div>
            Pour modifier les informations de votre compte, vous pouvez envoyer une demande par mail à : <br/><a
          href="mailto:contact.portail@libriciel.fr">contact.portail&#64;libriciel.fr</a>
        </div>
      </div>
    </div>
    <app-dash-block-commercial class="d-block d-md-none"></app-dash-block-commercial>
    <app-dash-block-dp class="d-block d-md-none" (hasDpEvent)="hasDp = $event" [hidden]="true"
    showTooltip="true"></app-dash-block-dp>
    @if (categories.length > 1) {
      <div class="p-4 block">
        <h3 class="mb-2">Mes applications</h3>
        @for (cat of categories; track cat) {
          <div class="mb-2">
            @if (cat.slug !== 'public') {
              <span>
                <app-badge class="me-1 ms-1"
                [label]="{id: cat.id, textcolor: cat.textcolor, backcolor: cat.backcolor, name: cat.name}"></app-badge>
              </span>
            }
          </div>
        }
      </div>
    }
  </div>
} @else {
}


<ng-template #loading>
</ng-template>

<ng-template #accountnotfound>
  <div class="alert alert-danger">
    <p>Compte introuvable</p>
    Merci de contacter le service client Libriciel
  </div>
</ng-template>
</div>


<ng-template #requestresetmodal let-modal>
  <form action="javascript:void(0)">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-password-title">
        Modification du mot de passe
      </h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()">
      </button>
    </div>
    <div class="modal-body container bg-white">
      <div>
        <p>Suite à votre confirmation, vous allez recevoir un mail contenant des informations détaillées vous permettant
        de finaliser la modification de votre mot de passe.</p>

        <p class="fw-bold">Souhaitez-vous confirmer votre demande de modification du mot de passe ?</p>
      </div>
    </div>
    <div class="modal-footer justify-content-between justify-content-md-end">
      <app-cancel-button (click)="modal.dismiss()"></app-cancel-button>
      <button type="submit" class="btn btn-primary" (click)="modal.close('Save click')">Confirmer
        <span class="d-none d-md-inline"> ma demande de modification</span>
      </button>
    </div>
  </form>
</ng-template>

<ng-template #disableaccountmodal let-modal>
  <form action="javascript:void(0)">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-delete-title">
        Demande de suppression de compte
      </h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()">
      </button>
    </div>
    <div class="modal-body container bg-white">
      <div>
        <div>
          <div class="alert alert-danger">
            Immédiatement après votre confirmation, vous ne pourrez plus vous connecter au Portail client.
            Votre compte utilisateur sera supprimé de la base de données Libriciel SCOP.
          </div>
          <p class="fw-bold">Souhaitez-vous confirmer votre demande de suppression de compte ?</p>

        </div>
      </div>
    </div>
    <div class="modal-footer justify-content-between justify-content-md-end">
      <app-cancel-button (click)="modal.dismiss()"></app-cancel-button>
      <button type="submit" class="btn btn-danger" (click)="modal.close('Save click')">Confirmer
        <span class="d-none d-md-inline"> ma demande de suppression</span>
      </button>
    </div>
  </form>
</ng-template>
